<ng-container *ngIf="tooltipInfo">
  <ng-template #popover>
    <span [innerHTML]="tooltipInfo.text | translate"></span>
  </ng-template>
  <a [ngbPopover]="popover" [popoverTitle]="tooltipInfo.title | translate" placement="top" [ngClass]="tooltipInfo.class"
    >{{ tooltipInfo.link | translate }}
    <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
  </a>
</ng-container>
